import React, { useState } from 'react';
import { Radio, RadioGroup, FormControlLabel } from '@material-ui/core';
import { makeStyles } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { designTokens } from '../../styles/designTokens';
import Button from '../Button';

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        gap: designTokens.spacing.md,
    },
    phoneSection: {},
    phoneLabel: {
        ...designTokens.typography.body,
        fontSize: '13px',
        color: designTokens.colors.primary,
        marginBottom: '4px',
        display: 'block',
    },
    phoneValue: {
        ...designTokens.typography.body,
        fontSize: '16px',
        lineHeight: '28px',
        display: 'block',
    },
    sectionTitle: {
        ...designTokens.typography.body,
        fontSize: '13px',
        color: designTokens.colors.primary,
        marginBottom: '4px',
        display: 'block',
    },
    radioGroup: {},
    radioOption: {
        backgroundColor: '#F5F5F5',
        borderRadius: '8px',
        padding: '8px 12px',
        margin: '0 0 8px 0',
        '&:hover': {
            backgroundColor: '#EEEEEE',
        },
    },
    radioLabel: {
        ...designTokens.typography.h3,
        lineHeight: '24px',
        '@media (max-width: 600px)': {
            fontSize: '15px',
        }
    },
    radio: {
        color: designTokens.colors.primary,
        '&.Mui-checked': {
            color: designTokens.colors.primary,
        }
    }
}));

const PatientSelectionStep = ({ phoneNumber, patients, onSelect, onCreateNew }) => {
    const classes = useStyles();
    const [selectedPatientId, setSelectedPatientId] = useState(null);

    const formatPhoneNumber = (phone) => {
        const numbers = phone.replace(/\D/g, '');

        if (numbers.startsWith('380') && numbers.length === 12) {
            return `+380 (${numbers.slice(3, 5)}) ${numbers.slice(5, 8)} ${numbers.slice(8, 10)} ${numbers.slice(10, 12)}`;
        }

        return phone;
    };

    const handleConfirm = () => {
        const patient = patients.find(p => p.id === selectedPatientId);
        if (patient) {
            onSelect(patient);
        }
    };

    return (
        <div className={classes.container}>
            <div className={classes.phoneSection}>
                <div className={classes.phoneLabel}>Телефон пацієнта:</div>
                <div className={classes.phoneValue}>{formatPhoneNumber(phoneNumber)}</div>
            </div>

            <div>
                <div className={classes.sectionTitle}>Оберіть пацієнта:</div>

                <RadioGroup
                    value={selectedPatientId}
                    onChange={(e) => setSelectedPatientId(Number(e.target.value))}
                    className={classes.radioGroup}
                >
                    {patients.map(patient => (
                        <FormControlLabel
                            key={patient.id}
                            value={patient.id}
                            control={<Radio className={classes.radio} />}
                            label={<span className={classes.radioLabel}>{patient.fullname}</span>}
                            className={classes.radioOption}
                        />
                    ))}
                </RadioGroup>
            </div>

            <Button
                variant="outlined"
                onClick={onCreateNew}
                icon={<AddIcon />}
                iconPosition="left"
                size="small"
            >
                Додати нового пацієнта
            </Button>

            <Button
                variant="primary"
                onClick={handleConfirm}
                disabled={!selectedPatientId}
                fullWidth
            >
                Підтвердити пацієнта
            </Button>
        </div>
    );
};

export default PatientSelectionStep;
